import styled, { css } from 'styled-components'
import { GRAYSCALE_DARK_TEXT, ADDITIONAL_YELLOW, BRAND_MAIN, GRAYSCALE_MEDIUM_TEXT } from './colors'
import { DEFAULT_FONT } from './typography'
import { fromTabletUp } from '../../styledUtils'
import { GRAYSCALE_LIGHT } from './colors'

export const UniParagraphAnchorStyles = css`
  ${DEFAULT_FONT}
  appearance: none;
  border: none;
  background: none;
  padding: 0;
  color: ${BRAND_MAIN};
  font-size: 15px;
  line-height: 22px;
  font-weight: 600;
  transition-duration: 0.1s;
  transition-property: all;
  text-decoration: underline;
  text-underline-offset: 2px;
  text-decoration-thickness: 1px;

  ${fromTabletUp(css`
    font-size: 16px;
    line-height: 24px;
  `)}

  ${fromTabletUp(css`
    font-size: 16px;
    line-height: 24px;
  `)}

  &:hover {
    text-decoration-thickness: 2px;
  }

  &:focus-visible {
    outline: solid 2px ${ADDITIONAL_YELLOW};
    outline-offset: 2px;
  }

  ${fromTabletUp(css`
    font-size: 16px;
  `)}
`

export const UniParagraphStyles = css`
  color: ${GRAYSCALE_DARK_TEXT};
  font-size: 15px;
  line-height: 22px;
  transition-duration: 0.1s;
  transition-property: all;

  ${DEFAULT_FONT}

  ${fromTabletUp(css`
    font-size: 16px;
    line-height: 24px;
  `)}

  a:not(.uni-button) {
    ${UniParagraphAnchorStyles}
  }
`

export const UniParagraphSmallStyles = css`
  font-size: 14px;
  line-height: 20px;
  margin: 8px 0;

  ${fromTabletUp(css`
    font-size: 15px;
    line-height: 22px;
    margin: 12px 0;
  `)}

  a {
    font-size: 14px;
    line-height: 20px;

    ${fromTabletUp(css`
      font-size: 15px;
      line-height: 22px;
    `)}
  }
`

export const UniParagraphSemiBoldStyles = css`
  font-weight: 600;
`

export const UniParagraphNoMarginStyles = css`
  margin: 0;

  ${fromTabletUp(css`
    margin: 0;
  `)}
`

export const UniParagraphNoMarginTopStyles = css`
  margin-top: 0;

  ${fromTabletUp(css`
    margin-top: 0;
  `)}
`

export const UniParagraph = styled.p<{
  $muted?: boolean
  $white?: boolean
  $small?: boolean
  $semiBold?: boolean
  $cursive?: boolean
  $textAlignEnd?: boolean
  $wide?: boolean
  $narrow?: boolean
  $truncated?: boolean
  $noMargin?: boolean
  $noMarginTop?: boolean
  $noMarginBottom?: boolean
}>`
  ${UniParagraphStyles}
  margin: 16px 0;

  ${fromTabletUp(css`
    margin: 24px 0;
  `)}

  ${(props) =>
    props.$muted &&
    css`
      color: ${GRAYSCALE_MEDIUM_TEXT};
    `}

  ${(props) =>
    props.$white &&
    css`
      color: ${GRAYSCALE_LIGHT};

      a:not(.uni-button) {
        color: ${GRAYSCALE_LIGHT};
      }
    `}

  ${(props) => props.$semiBold && UniParagraphSemiBoldStyles}

  ${({ $cursive = false }) =>
    $cursive &&
    css`
      font-style: italic;
    `}

  ${({ $textAlignEnd = false }) =>
    $textAlignEnd &&
    css`
      text-align: end;
    `}

  ${(props) => props.$small && UniParagraphSmallStyles}

  ${({ $wide }) =>
    $wide &&
    css`
      max-width: 800px;
    `}

  ${({ $narrow }) =>
    $narrow &&
    css`
      max-width: 400px;
    `}


  ${({ $truncated }) =>
    $truncated &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `}

  ${(props) => props.$noMargin && UniParagraphNoMarginStyles}

  ${(props) => props.$noMarginTop && UniParagraphNoMarginTopStyles}

  ${(props) =>
    props.$noMarginBottom &&
    css`
      margin-bottom: 0;

      ${fromTabletUp(css`
        margin-bottom: 0;
      `)}
    `}
`
